import { render, staticRenderFns } from "./LedgerList.vue?vue&type=template&id=54942e8b&scoped=true&"
import script from "./LedgerList.vue?vue&type=script&lang=js&"
export * from "./LedgerList.vue?vue&type=script&lang=js&"
import style0 from "./LedgerList.vue?vue&type=style&index=0&id=54942e8b&prod&lang=scss&scoped=true&"
import style1 from "./LedgerList.vue?vue&type=style&index=1&id=54942e8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54942e8b",
  null
  
)

export default component.exports